import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 5a3 3 0 0 1 3 3v.381l3.106 -1.552a2 2 0 0 1 2.894 1.789v6.765a2 2 0 0 1 -2.894 1.787l-3.106 -1.552v.382a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3zm-2 6h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0 -2","key":"svg-0"}]]

const IconVideoMinusFilled = createReactComponent('filled', 'video-minus-filled', 'VideoMinusFilled', __iconNode);

export default IconVideoMinusFilled;